import { base } from './de/base';
import { pages } from './de/pages';

/** German texts of the module, below its ID: `tenders.nav.tenders`. One file per area. */
export const de = { ...base, ...pages };
